import React from 'react';

interface VideoIconV2Props {
  style?: React.CSSProperties;
}

const VideoIconV2: React.FC<VideoIconV2Props> = ({ style }) => {
  return <img style={style} src="/static/images/video.png" />;
};

export default VideoIconV2;
